<template>
  <div class="header-m">
    <el-row>
      <el-col :span="20">
        <img
            src="https://gwsite-1302681310.cos.ap-beijing.myqcloud.com/assets/h5/other/logo.png"
            width="40%"
        />
      </el-col>
      <el-col :span="4">
        <img
            v-if="show"
            src="https://gwsite-1302681310.cos.ap-beijing.myqcloud.com/assets/h5/other/close.png"
            width="35%"
            @click="open"
        />
        <img
            v-else
            src="https://gwsite-1302681310.cos.ap-beijing.myqcloud.com/assets/h5/other/menu.png"
            width="50%"
            @click="open"
        />
      </el-col>
    </el-row>
    <el-collapse-transition>
      <div v-show="show" class="trans-menus">
        <!-- 滚动容器：绑定动态高度，开启垂直滚动 -->
        <div class="scroll" :style="{ height: transitionHeight }">
          <div class="transition-box color-1" @click="menuClick('/m/home')">
            <p class="title">首页</p>
            <p class="en-title">HOME PAGE</p>
          </div>
          <div class="transition-box color-2" @click="menuClick('/m/company')">
            <p class="title">企业介绍</p>
            <p class="en-title">COMPANY PROFILE</p>
          </div>
          <div class="transition-box color-3" @click="menuClick('/m/profession')">
            <p class="title">专业</p>
            <p class="en-title">SOLUTION</p>
          </div>
          <div class="transition-box color-4" @click="menuClick('/m/solution')">
            <p class="title">解决方案</p>
            <p class="en-title">MAJOR</p>
          </div>
          <div class="transition-box color-5" @click="menuClick('/m/team')">
            <p class="title">菁英团队</p>
            <p class="en-title">ELITE TEAM</p>
          </div>
          <div class="transition-box color-6" @click="menuClick('/m/about')">
            <p class="title">联系我们</p>
            <p class="en-title">CONTACT US</p>
          </div>
          <!-- 可新增更多菜单，测试滚动效果 -->
          <!-- <div class="transition-box color-1">
            <p class="title">测试菜单1</p>
            <p class="en-title">TEST 1</p>
          </div>
          <div class="transition-box color-2">
            <p class="title">测试菜单2</p>
            <p class="en-title">TEST 2</p>
          </div> -->
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
export default {
  name: "headers",
  data() {
    return {
      show: false,
      clientHeight: document.documentElement.clientHeight,
      transitionHeight: `${document.documentElement.clientHeight - 60}px` // 扣除头部60px高度
    };
  },
  watch: {
    clientHeight(newValue) {
      if (newValue) {
        this.transitionHeight = `${newValue - 60}px`;
      }
    }
  },
  mounted() {
    // 监听窗口大小变化，更新滚动容器高度
    window.addEventListener('resize', () => {
      this.clientHeight = document.documentElement.clientHeight;
    });
  },
  beforeDestroy() {
    // 移除监听，避免内存泄漏
    window.removeEventListener('resize', () => {
      this.clientHeight = document.documentElement.clientHeight;
    });
  },
  methods: {
    menuClick(e) {
      this.show = false;
      document.body.style.overflow = this.show ? 'hidden' : 'scroll';
      this.$router.push(e);
    },
    open() {
      this.show = !this.show;
      document.body.style.overflow = this.show ? 'hidden' : 'scroll'; // 防止页面整体滚动
    },
    moveHandle() {
      return;
    }
  }
};
</script>

<style lang="less" scoped>
.header-m {
  width: 100%;
  z-index: 999;
  position: relative; // 确保子元素z-index生效

  .el-row {
    padding: 0 18px;
    line-height: normal;
    height: 60px;
    display: flex;
    align-items: center; // 垂直居中，替代margin-top
    box-sizing: border-box;

    .el-col-20 {
      text-align: left;
    }

    .el-col-4 {
      text-align: right;
    }
  }

  // 菜单容器：占满屏幕剩余高度，固定定位防止溢出
  .trans-menus {
    position: fixed;
    top: 60px; // 对应头部高度
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;

    // 滚动容器：核心样式
    .scroll {
      width: 100%;
      height: 100%; // 继承父级高度（全屏剩余高度）
      overflow-y: auto; // 开启垂直滚动
      -webkit-overflow-scrolling: touch; // 移动端顺滑滚动
      box-sizing: border-box;
    }

    // 菜单项样式优化
    .transition-box {
      padding: 30px 52px; // 固定内边距，替代百分比
      text-align: left;
      box-sizing: border-box;

      // 不同背景色
      &.color-1 { background: #60A9FF; }
      &.color-2 { background: #4D9DFB; }
      &.color-3 { background: #3490FB; }
      &.color-4 { background: #1E82F5; }
      &.color-5 { background: #0274F6; }
      &.color-6 { background: #0366DE; }

      .title {
        font-size: 28px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 40px;
        letter-spacing: 2px;
        margin: 0 0 8px 0; // 清除默认margin，控制间距
      }

      .en-title {
        font-size: 20px;
        font-weight: 400;
        color: #D9D9D9;
        line-height: 28px;
        letter-spacing: 1px;
        margin: 0; // 清除默认margin
      }
    }
  }
}

// 隐藏滚动条（可选，美化样式）
::-webkit-scrollbar {
  width: 0;
  height: 0;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: transparent;
}
</style>